import React from 'react';
import { Box, Typography, Container, Link, IconButton } from '@mui/material';
import Logo from '../Assests/Logo.png';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import YouTubeIcon from '@mui/icons-material/YouTube';
import TwitterIcon from '@mui/icons-material/Twitter';

function Footer() {
  return (
    <Box
      sx={{
        backgroundColor: '#000000',
        color: '#ffffff',
        pt: { xs: 4, md: 6 },  // Smaller top padding on mobile
        pb: { xs: 3, md: 4 },  // Smaller bottom padding on mobile
        width: '100%',
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' }, // Stack on mobile
            justifyContent: 'space-between',
            flexWrap: 'wrap',
            mb: 4,
            gap: { xs: 3, md: 4 },
          }}
        >
          {/* Logo and Description */}
          <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', md: 'row' },
              gap: { xs: 2, md: 4 },
              mb: { xs: 3, md: 0 },
              alignItems: { xs: 'center', md: 'flex-start' },
            }}
          >
            <Box>
              <img
                src={Logo}
                alt="Armour Pro Logo"
                style={{ width: '120px', maxWidth: '100%', height: 'auto' }}
              />
            </Box>

            <Box sx={{ maxWidth: { xs: '100%', md: '300px' }, textAlign: { xs: 'center', md: 'left' } }}>
              <Typography variant="h6" sx={{ mb: 1, fontWeight: 'bold', color: '#ffffff' }}>
                Armour Pro
              </Typography>
              <Typography variant="body2" sx={{ color: '#2E9FFF', mb: 2 }}>
                Armour Pro provides high-performance coatings that bond seamlessly to surfaces,
                offering durable protection against wear and environmental damage.
              </Typography>
              <Box sx={{ display: 'flex', justifyContent: { xs: 'center', md: 'flex-start' }, gap: 1 }}>
                <IconButton href="https://facebook.com" target="_blank" sx={{ color: '#ffffff', '&:hover': { color: '#1877F2' } }}>
                  <FacebookIcon />
                </IconButton>
                <IconButton href="https://instagram.com" target="_blank" sx={{ color: '#ffffff', '&:hover': { color: '#E1306C' } }}>
                  <InstagramIcon />
                </IconButton>
                <IconButton href="https://youtube.com" target="_blank" sx={{ color: '#ffffff', '&:hover': { color: '#FF0000' } }}>
                  <YouTubeIcon />
                </IconButton>
                <IconButton href="https://twitter.com" target="_blank" sx={{ color: '#ffffff', '&:hover': { color: '#1DA1F2' } }}>
                  <TwitterIcon />
                </IconButton>
              </Box>
            </Box>
          </Box>

          {/* About Us Section */}
          <Box sx={{ mb: { xs: 3, md: 0 }, textAlign: { xs: 'center', md: 'left' } }}>
            <Typography variant="h6" sx={{ mb: 2, fontWeight: 'bold', color: '#ffffff' }}>
              About us
            </Typography>
            <Link href="#" underline="none" sx={{ color: '#aaaaaa', display: 'block', mb: 1.5, '&:hover': { color: '#ffffff' } }}>
              About products
            </Link>
            <Link href="#" underline="none" sx={{ color: '#aaaaaa', display: 'block', mb: 1.5, '&:hover': { color: '#ffffff' } }}>
              Packages
            </Link>
            <Link href="#" underline="none" sx={{ color: '#aaaaaa', display: 'block', '&:hover': { color: '#ffffff' } }}>
              Booking
            </Link>
          </Box>

          {/* Terms Section */}
          <Box sx={{ mb: { xs: 3, md: 0 }, textAlign: { xs: 'center', md: 'left' } }}>
            <Typography variant="h6" sx={{ mb: 2, fontWeight: 'bold', color: '#ffffff' }}>
              Terms
            </Typography>
            <Link href="#" underline="none" sx={{ color: '#aaaaaa', display: 'block', mb: 1.5, '&:hover': { color: '#ffffff' } }}>
              Warranty Info
            </Link>
            <Link href="#" underline="none" sx={{ color: '#aaaaaa', display: 'block', mb: 1.5, '&:hover': { color: '#ffffff' } }}>
              Surface Types
            </Link>
            <Link href="#" underline="none" sx={{ color: '#aaaaaa', display: 'block', '&:hover': { color: '#ffffff' } }}>
              Privacy Policy
            </Link>
          </Box>

          {/* Contact Section */}
          <Box sx={{ maxWidth: { xs: '100%', md: '300px' }, textAlign: { xs: 'center', md: 'left' } }}>
            <Typography variant="h6" sx={{ mb: 2, fontWeight: 'bold', color: '#ffffff' }}>
              Contact Us
            </Typography>
            <Typography variant="body2" sx={{ color: '#cccccc', mb: 2 }}>
              <strong>Armour Pro</strong><br />
              2-35/3 Madhura Nagar, Hyderabad, Telangana
            </Typography>
            <Typography variant="body2" sx={{ color: '#cccccc', mb: 2 }}>
              <strong>Gmail</strong><br />
              armourpro@gmail.com
            </Typography>
            <Typography variant="body2" sx={{ color: '#cccccc' }}>
              <strong>Contact Number:</strong><br />
              +91 9XXXX XXXXX
            </Typography>
          </Box>
        </Box>

        {/* Divider */}
        <Box
          sx={{
            height: '1px',
            background: 'linear-gradient(to right, #2E9FFF, #000000, #2E9FFF)',
            opacity: 0.4,
            mb: 3,
            mt: 2,
          }}
        />

        {/* Copyright */}
        <Box sx={{ textAlign: 'center', mt: 4, mb: 2 }}>
          <Typography variant="body2" sx={{ color: '#aaaaaa' }}>
            © 2025 Armour Pro. All rights reserved.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}

export default Footer;
